import styled from 'styled-components';
import COLOR from '../../../../styles/common/color';
import { FONT_STYLES } from '../../../../styles/common/font-styles';

const ListContainer = styled.div`
  ${({ theme }) => theme.container.sidePadding}
  padding-top: 70px;
  padding-bottom: 300px;
  text-align: center;

  @media screen and (max-width: 1700px) {
    padding-top: 70px;
    padding-bottom: 120px;
  }
`;

const ListTitle = styled.div`
  ${FONT_STYLES.P_B}
  font-size: 40px;
  margin-bottom: 40px;
`;

const ButtonBox = styled.div`
  height: 52px;
  margin-top: 10px;
  margin-bottom: 20px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin: 0 5px;

    & > div {
      svg,
      div {
        cursor: pointer;
      }
    }
  }
`;

const HorizonLine = styled.div`
  width: 45px;
  border-bottom: 3px solid ${COLOR.BLUE_3};
  margin: 40px auto;
`;

const ListTable = styled.div`
  clear: both;
  margin-top: 50px;
`;

const DataNotFound = styled.div`
  width: 100%;
  height: 715px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > p {
    ${FONT_STYLES.P_R}
    font-size: 36px;
  }
`;

const ListData = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid ${COLOR.GRAY_8};
  cursor: pointer;

  & > div:nth-child(1) {
    width: 53px;
    ${FONT_STYLES.P_R}
    margin-right: 20px;
  }

  & > div:nth-child(2) {
    width: 70px;
    margin: 0 10px;

    p:nth-child(1) {
      ${FONT_STYLES.P_SB}
      margin-bottom: 5px;
    }
    p:nth-child(2) {
      ${FONT_STYLES.P_B}
      font-size: 20px;
      margin-bottom: 5px;
    }
    p:nth-child(3) {
      ${FONT_STYLES.P_R}
      font-size: 14px;
    }
  }

  & > div:nth-child(3) {
    margin: 0 10px;
    text-align: left;

    p: nth-child(1) {
      font-size: 15px;
      margin-bottom: 10px;
    }
    p: nth-child(2) {
      ${FONT_STYLES.P_SB}
      font-size: 18px;
    }
  }
`;

const ListDataInfo = styled.div`
  ${FONT_STYLES.P_M}
  display: flex;
  margin-left: auto;
  font-size: 18px;

  & > div {
    margin: 0 10px;
    :nth-child(1) {
      width: 100px;
    }
    :nth-child(2) {
      width: 70px;
    }

    p:nth-child(1) {
      padding-bottom: 5px;
    }
  }
`;

const PaginationBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;

  & > svg {
    cursor: pointer;
  }

  .prev-btn {
    margin-right: 30px;
  }
  .next-btn {
    margin-left: 30px;
  }
`;

export {
  ListContainer,
  ListTitle,
  ButtonBox,
  HorizonLine,
  ListTable,
  DataNotFound,
  ListData,
  ListDataInfo,
  PaginationBox,
};
